import { render } from "./FilterActions.vue?vue&type=template&id=096d363a"
import script from "./FilterActions.vue?vue&type=script&lang=js"
export * from "./FilterActions.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/Videos/call-center-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__